import { configureStore } from '@reduxjs/toolkit';

import AlertsManagementReducer from './slice/AlertManagementSlice';
import ApprovedStationManagementReducer from './slice/ApprovedStationManagementSlice';
import ChargingSessionReducer from './slice/ChargingSessionSlice';
import DeviceManagementReducer from './slice/DeviceManagementSlice';
import DynamicBasePriceManagementReducer from './slice/DynamicBasePriceManagementSlice';
import DynamicOffPeakPriceManagementReducer from './slice/DynamicOffPeakPriceManagementSlice';
import DynamicPeakPriceManagementReducer from './slice/DynamicPeakPriceManagementSlice';
import FacilityTagReducer from './slice/FacilityTagSlice';
import FileUploadStreamReducer from './slice/FileUploadStreamSlice';
import GuestChargingReducer from './slice/GuestChargingSlice';
import MaintenanceScheduleManagementReducer from './slice/MaintenanceScheduleManagementSlice';
import NotificationReducer from './slice/NotificationSlice';
import PendingStationManagementReducer from './slice/PendingStationManagementSlice';
import ResetReduxReducer from './slice/ReduxResetSlice';
import RejectStationManagementReducer from './slice/RejectedStationManagementSlice';
import ReportsReducer from './slice/ReportSlice';
import RoleManagementReducer from './slice/RoleManagementSlice';
import ScheduleManagementReducer from './slice/ScheduleManagementSlice';
import TransactionReducer from './slice/TransactionManagementSlice';
import UserManagementReducer from './slice/UserManagementSlice';
import VlbcReducer from './slice/VlbcSlice';

// Store configure with the reducer
export const store = configureStore({
  reducer: {
    resetRedux: ResetReduxReducer,
    approvedStation: ApprovedStationManagementReducer,
    rejectStation: RejectStationManagementReducer,
    pendingStation: PendingStationManagementReducer,
    dynamicBasePrice: DynamicBasePriceManagementReducer,
    dynamicPeakPrice: DynamicPeakPriceManagementReducer,
    dynamicOffPeakPrice: DynamicOffPeakPriceManagementReducer,
    maintenanceSchedule: MaintenanceScheduleManagementReducer,
    roles: RoleManagementReducer,
    schedules: ScheduleManagementReducer,
    users: UserManagementReducer,
    fileUpload: FileUploadStreamReducer,
    device: DeviceManagementReducer,
    report: ReportsReducer,
    alerts: AlertsManagementReducer,
    transaction: TransactionReducer,
    notification: NotificationReducer,
    guestCharging: GuestChargingReducer,
    facilityTags: FacilityTagReducer,
    chargingSession: ChargingSessionReducer,
    vlbc: VlbcReducer,
  },
});

// RootState and AppDispatch types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
